import { JsonObject } from "../interface/json";
const d = window as any;
export const weChatService = {
  getWxcode(info: JsonObject): Promise<any> {
    const path = "public/wx_interface/wxcode";
    return d.$sk.$skxhrp(path, info);
  },

  getCode(info): Promise<any> {
    const path = "api/member/verify/token/getbycode";
    return d.$sk.$skxhrp(path, info);
  },

  getOAuth(info): Promise<any> {
    const path = "member/form/GetOAuthUrlByWeChatId";
    return d.$sk.$skxhrp(path, info);
  },

  getByOpenId(info): Promise<any> {
    const path = "contact/getByOpenId";
    return d.$sk.$skxhrp(path, info);
  },

  weChatQrCode(info): Promise<any> {
    const path = "api/wechat/qrcode/get";
    return d.$sk.$skxhrp(path, info);
  },
  getImg(info): Promise<any> {
    const path = "api/wechat/qrcode/GetTmpImg";
    return d.$sk.$skxhrp(path, info);
  },
};
